//Обʼєкт з посиланнями на ДОМ елементи

const refs = {
  mobMenu: document.querySelector('.mobile-menu'),  // мобільне меню в хедері
  body: document.body,                              // тіло документа
};

export default refs;



